import { useState } from "react";
import Logo from "../../../general/Logo";
import FadeIn from "../../../general/FadeIn";
import RoundedInput from "../../../general/RoundedInput";
import OrangeButton from "../../../general/OrangeButton";
import Api from "../../../../services/Api";

/**
 * LoginPage — formulário de autenticação.
 * Chama Api.login() e, em seguida, Api.me() para obter o nome do usuário antes de redirecionar.
 * @param {function} navigate - redireciona para outra página após o login
 * @param {function} onLogin  - recebe os dados do usuário autenticado e atualiza o estado global
 */
function LoginPage({ navigate, onLogin }) {
  // Campo de email digitado pelo usuário
  const [login, setLogin] = useState("");
  // Campo de senha digitado pelo usuário
  const [senha, setSenha] = useState("");
  // Mensagem de erro exibida abaixo do formulário
  const [error, setError] = useState("");
  // Impede cliques duplos enquanto a requisição está em andamento
  const [loading, setLoading] = useState(false);

  // Realiza login em dois passos: obtém o token e depois busca os dados do usuário
  const handleSubmit = async () => {
    setError("");
    setLoading(true);
    try {
      const data = await Api.login(login, senha);
      const me = await Api.me(data.access_token);
      Api.setToken(data.access_token);
      onLogin({ name: me.name, username: me.username, token: data.access_token });
      navigate("search");
    } catch (e) {
      setError(e.message || "Não foi possível conectar ao servidor.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#fafafa",
        padding: 24,
      }}
    >
      <FadeIn>
        <div style={{ textAlign: "center", marginBottom: 40 }} onClick={() => navigate("search")}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Logo size="large" />
          </div>
        </div>
      </FadeIn>

      <FadeIn delay={150}>
        <h1
          style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 32,
            fontWeight: 700,
            color: "#2d2d2d",
            textAlign: "center",
            marginBottom: 36,
          }}
        > 
          Faça seu login
        </h1>
      </FadeIn>

      <div style={{ width: "100%", maxWidth: 400, display: "flex", flexDirection: "column", gap: 20 }}>
        <FadeIn delay={250}>
          <RoundedInput
            placeholder="Nome de usuário ou Email"
            value={login}
            onChange={(e) => setLogin(e.target.value)}
          />
        </FadeIn>
        <FadeIn delay={350}>
          <RoundedInput
            placeholder="Senha"
            type="password"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
          />
        </FadeIn>

        <FadeIn delay={450}>
          <div style={{ textAlign: "center", marginTop: 16 }}>
            <OrangeButton onClick={handleSubmit} disabled={loading}>
              {loading ? "Entrando..." : "Acessar"}
            </OrangeButton>
            {error && (
              <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: "#e53935", marginTop: 10 }}>
                {error}
              </p>
            )}
          </div>
        </FadeIn>

        <FadeIn delay={500}>
          <div style={{ textAlign: "center", marginTop: 8 }}>
            <p
              style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 14,
                color: "#888",
                marginBottom: 4,
              }}
            >
              Esqueceu a sua senha?
            </p>
            <span
              style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 14,
                color: "#E8956A",
                cursor: "pointer",
              }}
              onClick={() => navigate("change-password")}
            >
              Recuperar Senha
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={600}>
          <div style={{ textAlign: "center", marginTop: 40 }}>
            <h2
              style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 24,
                fontWeight: 700,
                color: "#2d2d2d",
                marginBottom: 20,
              }}
            >
              Não tem cadastro?
            </h2>
            <OrangeButton onClick={() => navigate("register")}>
              Cadastre-se
            </OrangeButton>
          </div>
        </FadeIn>
      </div>
    </div>
  );
}

export default LoginPage;
